module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAEHSURBVCiRnZIhzoQwEIUnm9RUdkxNTSW6F0D3CD1E6/cq3KgCAYKegmwqMIS3CrJ/gGT/fcmomc/M+4g+EkJorLWdMWYWQmxCiM0YM1truxBCQ1dxzj2ZeY0xIueMWitqrcg5I8YIZl6dc88TpLVG3/e4S9/30FrjgEMIDTOvwzAAAEop8N5DSgkpJbz3KKUcMDOvIYSGrLVdjPGAlFIgoj+jlDrgGCOstR0ZY+acMwDAe3+C9vHeAwByzjDGzCSE2JZlAQBIKW9BKSUAoNYKIcT2uHzxF3lorV/jOBIRUdu2t4f7bpom0lq/fn/OXsfe4dd1/CzApz3MvKaUTsqllK6V2/Mfyd+bQ0AyIgeLhQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/Group 42.png
// module id = nWWc
// module chunks = 8